module.exports = __webpack_public_path__ + "img/3.e0d9fb45.svg";